import { collection, deleteDoc, doc, onSnapshot, query } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";


const UpdateSyllabus = () => {


  const [syllabusList, setSyllabusList] = useState([]);

  useEffect(()=>{
   const q = query(collection(db, "syllabusUpload"));
    onSnapshot(q, (querySnapshot) => {
   let filesArry = [];
   querySnapshot.forEach((doc) => {
     filesArry.push({id:doc.id,...doc.data()});
   });
   setSyllabusList(filesArry);
 });
  },[])
  return (
    <div className="justify-center pt-8">    
       <div className="min-h-screen text-lg font-bold text-center p-3 lg:mr-2 mt-4">
            <div className="grid lg:grid-cols-9 gap-4 sm:grid-cols-5  md:grid-cols-5 grid-cols-3">
             {syllabusList?.map((item , index)=>(
              <div key={index} className="lg:w-32 lg:h-38 md:w-32 md:h-38 sm:w-32 sm:h-38  text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600">
                <div className="">
                  <div className="hidden">{++index}</div>     
            <div className='' ><a href={item.pictureUrl} target="blank"><img src='../assets/pdf.png' className=' lg:h-32 lg:w-32 md:h-32 md:w-32 sm:h-32 sm:w-32' alt='pdf' /></a></div>           
                  <h1 className="text-sm">{item.bookName}</h1>
                  <span className="text-sm">{item.className}</span>
                </div>
              </div>
            ))}
            </div>
          </div>
    </div>
  )
}

export default UpdateSyllabus